import { inject, Signal } from '@angular/core';
import { FeatureToggleManagerService } from '@lentau/core/feature-toggle';
import { GrowthBookValue } from '@lentau/core/growth-book/shared';

const EXPERIMENT_NAME: string = 'exp_b2b_web_mob_checkout';

export const b2bWebMobileExperiment: () => Signal<boolean> = () => {
  const featureToggleManagerService: FeatureToggleManagerService = inject(FeatureToggleManagerService);

  return featureToggleManagerService.checkParam(EXPERIMENT_NAME, GrowthBookValue.Test);
};
